

export const environment = {
  production: false,
// backendApiURL: "http://api.healthconsciousapp.com/",
//backendApiURL: "http://3.137.125.107/",
//  backendApiURL: "https://api.healthco.app/",
// backendApiURL: "https://apievolve.zimblecode.com/",
backendApiURL: "https://apihealthco.codknox.com/",

// backendApiURL: "https://8a5c-122-161-197-132.in.ngrok.io/",
  translate: 'en' // english
};

